/**
 * Adds `nice: true` to scale fields that don't already have explicit min/max,
 * restoring G2 v2 behavior where linear axes extend to "nice" round tick values
 * beyond the data range. G2 v4 defaults `nice` to false.
 * Skips fields with explicit min/max to avoid interfering with fixed ranges.
 */
export const withNiceScale = (cols: any): any => {
	if (!cols) return cols;
	const result = {};
	Object.keys(cols).forEach((key) => {
		const field = cols[key];
		const hasExplicitBounds = field && (field.min !== undefined || field.max !== undefined);
		result[key] = hasExplicitBounds ? field : { nice: true, ...field };
	});
	return result;
};
